import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../components/header_logged'
import OuvidLogged from '../../../components/auth/ouvidoria'
import Head from '../../../components/head'


function OuvidLoggedScreen () {
    return (
        <Fragment>
            <Head titulo="Módulo Geral de Ouvidoria" />
            <HeaderLogged />
            <Container>
                <OuvidLogged />
            </Container>
        </Fragment>
    );
}

export default OuvidLoggedScreen;